export interface BaseEntite {
    id: number;
    name: string;
}

export interface BaseEntiteStatique<T extends NouvelleEntite<BaseEntite> = BaseEntite> {
    new (...args: unknown[]): T;
    key: string;
}

/* class decorator */
export function EntiteStatique(): <U extends BaseEntiteStatique>(constructor: U) => void {
    return <U extends BaseEntiteStatique>(constructor: U) => {
        constructor;
    };
}

export interface BaseEntiteSommaireStatique<T extends NouvelleEntite<BaseEntite>> extends BaseEntiteStatique {
    new (...args: unknown[]): T;
    key: string;
    proprietesSommaire: (keyof T)[];
}

/* class decorator */
export function EntiteSommaireStatique<TEntite extends NouvelleEntite<BaseEntite>>(): <
    U extends BaseEntiteSommaireStatique<TEntite>
>(
    constructor: U,
) => void {
    return <U extends BaseEntiteSommaireStatique<TEntite>>(constructor: U) => {
        constructor;
    };
}

export interface FiltrableEntiteStatique<T> {
    new (...args: unknown[]): T;
    // properties that can only be included in response's body when user who initiated the request is not connected
    // if empty, no data can be returned to non-connected user
    non_privileged_properties?: (keyof T)[];

    // properties that can only be included in response's body when user who initiated the request is connected, but not admin
    // if empty, will return every properties, except the one listed in list "admin_privileged_accessible_properties"
    regular_privileged_properties?: (keyof T)[];

    // properties that can only be included in response's body when user who initiated the request is connected & admin
    // if empty, will return every properties
    admin_privileged_properties?: (keyof T)[];
}

export function FiltrableEntiteStatique<T>(): <U extends FiltrableEntiteStatique<T>>(constructor: U) => void {
    return <U extends FiltrableEntiteStatique<T>>(constructor: U) => {
        constructor;
    };
}

export type NouvelleEntite<T extends BaseEntite> = Omit<T, 'id'>;

export * from './activite.entity';
export * from './authentification.entity';
export * from './contact.entity';
export * from './contact-activite.entity';
export * from './inscription.entity';
export * from './fournisseur.entity';
export * from './centre-service-scolaire.entity';
export * from './css-contact.entity';
export * from './reservation.entity';
export * from './formulaire-reservation.entity';
export * from './lieu.entity';
export * from './lieu-activite.entity';
export * from './utilisateur-connecte.entity';
export * from './thematique.entity';
export * from './fichier.entity';
export * from './client.entity';
export * from './client-contact.entity';
export * from './client-lieu.entity';
export * from './error.entity';
export * from './calendrier-scolaire.entity';
export * from './journee-pedagogique.entity';
export * from './langue.entity';
export * from './image.entity';
export * from './options.entity';
export * from './etiquette.entity';
export * from './categorie.entity';
export * from './produit.entity';
export * from './activite-produit.entity';
export * from './historique-prix-produit.entity';
export * from './historique-logs.entity';
export * from './entente.entity';
export * from './modele-horaire.entity';
export * from './note-entente.entity';
export * from './modele-courriel.entity';
